import { baseInputClasses, inputStateVariants } from '~kui/components/KUI/Core/Input/inputClassList';

// Trigger classes for select component (with cursor pointer and padding)
export const triggerClassList = cva(`${baseInputClasses} cursor-pointer px-3 py-[3px]`, {
  variants: {
    inputState: inputStateVariants,
  },
});

// Anchor classes for search component (with padding-end only)
export const anchorClassList = cva(`${baseInputClasses} pe-3`, {
  variants: {
    inputState: inputStateVariants,
  },
});

// Common content classes for dropdown
export const contentClasses = 'border-foreground mt-1 w-full overflow-hidden rounded-lg border bg-white shadow-sm';

// Common viewport classes for dropdown content
export const viewportClasses = '![scrollbar-width:thin]';

// Common item classes for options
export const itemClasses
  = 'text-foreground data-[disabled]:text-muted-foreground data-[highlighted]:text-foreground relative flex cursor-pointer items-center rounded-sm px-8 py-3 leading-none select-none data-[disabled]:pointer-events-none data-[highlighted]:bg-secondary data-[highlighted]:outline-none';

// Common empty state classes for search combobox
export const emptyClasses = 'text-foreground py-2 text-center text-xs font-medium';
